import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ClienteTipo } from '../cliente-tipo';
import { ClienteTipoFilterSearch } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ClienteTipoCrudHttpService implements Crud<ClienteTipo> {
    resource = 'clientetipo';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os clientes tipos cadastrados */
    search(): Observable<ClienteTipo[]> {
        return this.crudService.search<ClienteTipo>(this.resource);
    }

    /** Pesquisa todos os clientes tipos cadastrados utilizando o filtro informado */
    searchWithFilter(filter: ClienteTipoFilterSearch): Observable<ClienteTipo[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<ClienteTipo>(this.resource, {params});
    }

    /** Procura um único cliente tipo através do seu ID */
    find(id: number): Observable<ClienteTipo> {
        return this.crudService.find<ClienteTipo>(this.resource, id);
    }

    /** Carrega um único cliente tipo através do seu ID */
    load(id: number): Observable<ClienteTipo> {
        return this.crudService.load<ClienteTipo>(this.resource, id);
    }

    /** Insere um novo cliente tipo */
    insert(entity: ClienteTipo): Observable<ClienteTipo> {
        return this.crudService.insert<ClienteTipo>(this.resource, entity);
    }

    /** Altera um cliente tipo existente */
    update(entity: ClienteTipo): Observable<ClienteTipo> {
        return this.crudService.update<ClienteTipo>(this.resource, entity);
    }

    /** Exclui um cliente tipo através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
